import "./Navbar.css";

import {
  Container,
  Dropdown,
  Image,
  Nav,
  Navbar,
} from "@themesberg/react-bootstrap";
import { activateGeod, closeGeod } from "../Store";
import {
  faSignOutAlt,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Profile3 from "../assets/img/team/profile-picture-3.png"; // Static fallback image
import { connect } from "react-redux";
import { NavLink, useHistory } from "react-router-dom";
// import OtpNavbarComp from "./OtpNavbarComp";

const CustomNavbar = (props) => {
  const [isSelected, setIsSelected] = useState(false);
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const signOut = (e) => {
    e.preventDefault();
    try {
      const u = sessionStorage.getItem("userName");
      const pk = sessionStorage.getItem("pkUserId");
      if (u) localStorage.setItem("userName", u);
      if (pk) localStorage.setItem("pkUserId", pk);
    } catch (err) {}
    props.activateGeod({ title: false });
    sessionStorage.clear();
  };


  //   let userProfile = sessionStorage.getItem("userProfile");

  // let profileImageSrc = Profile3; // default fallback

  // if (userProfile) {
  //   // If already full base64 string
  //   if (userProfile.startsWith("data:image")) {
  //     profileImageSrc = userProfile;
  //   } else {
  //     // Assume raw base64 string
  //     profileImageSrc = `data:image/jpeg;base64,${userProfile}`;
  //   }
  // }

  let userProfile = sessionStorage.getItem("userProfile");

  let profileImageSrc = Profile3; // fallback by default

  if (
    userProfile &&
    userProfile !== "null" &&
    userProfile !== "undefined" &&
    userProfile.trim() !== ""
  ) {
    if (userProfile.startsWith("data:image")) {
      profileImageSrc = userProfile;
    } else {
      const cleanBase64 = userProfile.replace(/\s/g, "");
      profileImageSrc = `data:image/jpeg;base64,${cleanBase64}`;
    }
  }


  const navigate = useHistory();

  return (
    <>
      <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
        <Container fluid className="px-0">
          <div className="d-flex justify-content-between w-100">
            <div className="d-flex align-items-center"></div>
            <Nav className="align-items-center justify-content-space-around">
              {/* <OtpNavbarComp/> */}
              {/* <div className="aboutdiv">
                <NavLink to="/about">
                  <h4
                    className={`p-4 mt-2 aboutcls ${isSelected ? "selected" : ""}`}
                    onClick={() => setIsSelected(true)}
                  >
                    About Us
                  </h4>
                </NavLink>
              </div> */}

              {/* Dropdown toggle for profile */}
              <Dropdown as={Nav.Item}>
                <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0 ">
                  <div className="media d-flex align-items-center">
                    {/* Display the profile image */}
                    <Image
                      whiletap={{ scale: 0.6 }}
                      src={profileImageSrc}
                      alt="profileimg"
                      className="user-avatar md-avatar rounded-circle"
                      onError={(e) => {
                        e.target.onerror = null; // prevent infinite loop
                        e.target.src = Profile3;
                      }}
                    />
                    <br />
                    <br />
                    <br />
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2">
                  {/* <Dropdown.Item className="fw-bold">
                    <FontAwesomeIcon icon={faUser} className="me-2" />
                    {role === "customer" || role === "dealer"
                      ? sessionStorage.getItem("firstName")
                      : sessionStorage.getItem("firstName") +
                        " " +
                        sessionStorage.getItem("lastName")}
                    / {sessionStorage.getItem("role")}
                  </Dropdown.Item> */}



                  <Dropdown.Item as="div" className="fw-bold user-info-dropdown">
                    <div className="user-info-text">
                      <div className="user-name">
                        <FontAwesomeIcon icon={faUser} className="me-2 text-primary mt-1" />
                        {sessionStorage.getItem("firstName")}
                        {role !== "customer" && role !== "dealer"
                          ? " " + sessionStorage.getItem("lastName")
                          : ""}
                      </div>
                      <div className="user-role text-muted">Role: {sessionStorage.getItem("role")}</div>
                    </div>
                  </Dropdown.Item>


                  <Dropdown.Item className="fw-bold" onClick={(e) => signOut(e)}>
                    <FontAwesomeIcon
                      icon={faSignOutAlt}
                      className="text-danger me-2"
                    />{" "}
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              {/* Dropdown toggle end */}
            </Nav>
          </div>
        </Container>
      </Navbar>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    geod: state.geod,
  };
};

const mapDispatchToProps = {
  activateGeod,
  closeGeod,
};

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(CustomNavbar);
export default AppContainer;
